import { render } from "./FormImageUpload.vue?vue&type=template&id=3cbed331&scoped=true"
import script from "./FormImageUpload.vue?vue&type=script&lang=js"
export * from "./FormImageUpload.vue?vue&type=script&lang=js"

import "./FormImageUpload.vue?vue&type=style&index=0&id=3cbed331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbed331"]])

export default __exports__